module.exports = __webpack_public_path__ + "img/thc_logo.f54dac98.jpeg";